<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="formData.tanggal_awal"
          type="date"
          label="Dari Tanggal"
          outlined
          clearable
          dense
          autofocus
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="formData.tanggal_akhir"
          type="date"
          label="Sampai Tanggal"
          outlined
          clearable
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="formData.kv"
          label="Kode Kapal"
          outlined
          clearable
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn
          color="primary"
          @click="fetchLaporan"
          :disabled="!formData.tanggal_awal || !formData.tanggal_akhir"
        >
          Cari
        </v-btn>
      </v-col>
    </v-row>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">LAPORAN TAGIHAN PER KAPAL</h2>
        </div>
      </div>

      <div class="mt-4">
        <div v-for="(group, idx) in data" :key="idx" class="mb-4">
          <h2>
            Kapal: {{ vesselName(group.vessel) }}
            <span v-if="group.vessel"
              >(KV: {{ group.vessel.kv }}, Voy:
              {{ group.vessel.voy || "-" }})</span
            >
          </h2>

          <div
            v-for="(kodeGroup, kidx) in group.kode_nota_groups"
            :key="kidx"
            class="mb-3 ml-2"
          >
            <h3>Kode Nota: {{ kodeGroup.kode_nota }}</h3>
            <table width="100%">
              <thead>
                <th>No Nota</th>
                <th>Tgl Nota</th>
                <th>Kode TTB</th>
                <th>No TTB Jkt</th>
                <th>Customer</th>
                <th>Koli</th>
                <th>Kubikasi</th>
                <th>Tonase</th>
                <th class="text-right">Nominal</th>
              </thead>
              <tbody>
                <tr v-for="item in kodeGroup.items" :key="item.id">
                  <td>{{ item.nomor_nota }}</td>
                  <td>{{ formatDate(item.tgl_nota) }}</td>
                  <td>{{ firstKodeTTB(item.invoice_detil) }}</td>
                  <td>{{ firstNoTTBJkt(item.invoice_detil) }}</td>
                  <td>
                    {{ customerName(item.customer, item.ditagih_kepada) }}
                  </td>
                  <td class="text-center">
                    {{ totalKoliIn(item.invoice_detil) }}
                  </td>
                  <td class="text-center">
                    {{ totalKubikasi(item.invoice_detil) }}
                  </td>
                  <td class="text-center">
                    {{ totalTonase(item.invoice_detil) }}
                  </td>
                  <td class="text-right">
                    {{ formatCurrency(totalInvoice(item)) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="8" class="text-right">
                    <b>Subtotal {{ kodeGroup.kode_nota }}:</b>
                  </td>
                  <td class="text-right">
                    <b>{{ formatCurrency(groupTotal(kodeGroup.items)) }}</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="text-right mt-2">
            <b>Total Kapal: {{ formatCurrency(groupTotal(group.items)) }}</b>
          </div>
        </div>
      </div>
    </main>

    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal_awal: "",
        tanggal_akhir: "",
        kv: ""
      },
      data: []
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      const params = new URLSearchParams();
      params.append("tanggal_awal", this.formData.tanggal_awal);
      params.append("tanggal_akhir", this.formData.tanggal_akhir);
      if (this.formData.kv) params.append("kv", this.formData.kv);

      await axios
        .get(`invoice/laporan-tagihan-per-kapal?${params.toString()}`)
        .then(res => {
          if (!res.data || res.data.length === 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
          alert(err.response?.data?.message || "Gagal memuat laporan");
        });
    },
    totalKubikasi(data) {
      let total = 0;

      (data || []).forEach(invoice => {
        (invoice.ttb?.ttb_rinci || []).forEach(rinci => {
          total += rinci.m3;
        });
      });

      return total.toFixed(2);
    },
    totalTonase(data) {
      let total = 0;

      (data || []).forEach(invoice => {
        (invoice.ttb?.ttb_rinci || []).forEach(rinci => {
          total += rinci.ton;
        });
      });

      return total.toFixed(2);
    },
    totalKoliIn(data) {
      let total = 0;

      (data || []).forEach(invoice => {
        total += parseInt(invoice.koli_in || 0);
      });

      return total || "-";
    },
    firstKodeTTB(data) {
      if (!data || data.length === 0) return "-";
      return data[0].kodettb || "-";
    },
    firstNoTTBJkt(data) {
      if (!data || data.length === 0) return "-";
      return data[0].nottb_jakarta || data[0].nottb || "-";
    },
    totalInvoice(item) {
      return (
        Math.abs(item.i_total || 0) +
        Math.abs(item.ii_total || 0) +
        Math.abs(item.biaya_lain_total || 0)
      );
    },
    groupTotal(items) {
      return (items || []).reduce(
        (acc, cur) => acc + this.totalInvoice(cur),
        0
      );
    },
    vesselName(vessel) {
      if (!vessel) {
        return "Tanpa Kapal";
      }
      return vessel.nama_kapal || vessel.vessel || "Tanpa Nama";
    },
    customerName(customer, ditagihKepada) {
      if (customer) {
        return customer.nama || customer.nama_lengkap || "-";
      }

      if (!ditagihKepada) {
        return "-";
      }
      return ditagihKepada;
    },
    formatDate(date) {
      if (!date) {
        return "-";
      }

      const d = new Date(date);
      if (Number.isNaN(d.getTime())) {
        return "-";
      }

      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num || 0);
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}
</style>
